import { ContactInputFields } from '@apps/contactCollector/guest/ContactCollectorGuest.controller';
import { useState } from 'react';

export type EventFormContactData = Readonly<{
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  region?: string;
  country?: string;
  countryCode?: string;
}>;

export const EMPTY_CONTACT_VALUES: ContactInputFields = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  address1: '',
  address2: '',
  postalCode: '',
  city: '',
  region: '',
  country: 'United States',
  countryCode: 'US',
  validated: false,
};

export type EventFormValues = Readonly<{
  formValues: Record<string, string>;
  attendanceValue: boolean | null;
  contactValues: EventFormContactData;
}>;

export const useEventFormState = (initialValues: Partial<EventFormValues>) => {
  const [formState, setFormState] = useState<EventFormValues>({
    formValues: initialValues.formValues || {},
    attendanceValue: initialValues.attendanceValue || null,
    contactValues: initialValues.contactValues || EMPTY_CONTACT_VALUES,
  });

  return { formState, setFormState };
};
